export default __webpack_public_path__ + "media/images/running-6384ae28be057ef526c8c51fcf6909ad.jpg";